(() => {
  const schemes = ['scheme-auto', 'scheme-dark', 'scheme-light'];
  const update = () => {
    const displayMode = window.swinger.user.getDisplayMode();
    const applyingScheme = `scheme-${displayMode}`;
    schemes.forEach((scheme) => {
      document.documentElement.classList[scheme === applyingScheme ? 'add' : 'remove'](scheme);
    });
  };
  update();
  document.addEventListener('swinger.user:authchange', update);
})();
